import styled, { css } from 'styled-components';
import { Layout } from '../../../types';
import { useBanner } from '../../bannerProvider';
import type { BlockProps } from '../_block';
import { Block } from '../_block';

export type MediaBlockProps = BlockProps & {
  layout: Layout;
  height?: number;
};

export function MediaBlock({
  children,
  layout,
  height,
  ...forwardingProps
}: MediaBlockProps) {
  const {
    contentDirection,
    stretchBackground,
    outerMargin,
    contentVerticalPadding,
    contentHorizontalPadding,
    borderRadius,
    mobileView
  } = useBanner();

  const isColumn = contentDirection === 'column';
  const isSideBannerLayout = [Layout.LeftBanner, Layout.RightBanner].includes(
    layout
  );
  const isEmbeddedBanner =
    layout === Layout.EmbeddedBanner || (mobileView && isSideBannerLayout);

  return (
    <Container
      {...forwardingProps}
      _isColumn={isColumn}
      _isEmbeddedBanner={isEmbeddedBanner}
      _stretchBackground={stretchBackground}
      _outerMargin={outerMargin}
      _verticalPadding={contentVerticalPadding}
      _horizontalPadding={contentHorizontalPadding}
      _borderRadius={borderRadius}
      _height={height}
    >
      {children}
    </Container>
  );
}

const Container = styled(Block)<{
  _isColumn: boolean;
  _isEmbeddedBanner: boolean;
  _stretchBackground: boolean;
  _outerMargin: number;
  _verticalPadding: number | [number, number];
  _horizontalPadding: number;
  _borderRadius: number | undefined;
  _height: number | undefined;
}>`
  ${({
    _isColumn,
    _isEmbeddedBanner,
    _stretchBackground,
    _outerMargin,
    _verticalPadding,
    _horizontalPadding,
    _borderRadius,
    _height
  }) =>
    _isColumn &&
    _isEmbeddedBanner &&
    css`
      width: auto;
      max-width: none !important;
      ${_stretchBackground && !!_height && `height: ${_height}px;`};

      margin-inline: -${_stretchBackground
          ? _outerMargin
          : _horizontalPadding}px;

      &:first-child {
        margin-top: -${typeof _verticalPadding === 'number'
            ? _verticalPadding
            : _verticalPadding[0]}px;
        ${_borderRadius &&
        css`
          overflow: hidden;
          border-radius: ${_borderRadius}px ${_borderRadius}px 0 0;
        `};
      }

      &:last-child {
        margin-bottom: -${typeof _verticalPadding === 'number'
            ? _verticalPadding
            : _verticalPadding[1]}px;
        ${_borderRadius &&
        css`
          overflow: hidden;
          border-radius: 0 0 ${_borderRadius}px ${_borderRadius}px;
        `};
      }

      & + & {
        margin-top: 0;
      }
    `}
`;
